// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";

// function UpdatedAssignToRole({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [roleName, setRoleName] = useState("");
//   const [roleCode, setRoleCode] = useState("");
//   const [description, setDescription] = useState("");
//   const [isOpenRoleDetails, setIsOpenRoleDetails] = useState(true);
//   const toggleAccordionRoleDetails = () => setIsOpenRoleDetails(!isOpenRoleDetails);
//   const [branchOptions, setBranchOptions] = useState([]);
//   const [selectedBranches, setSelectedBranches] = useState([]);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const toggleAccordionShareBranch = () => setIsOpenShareBranch(!isOpenShareBranch);

//   const [studentOptions, setStudentOptions] = useState([]);
//   const [selectedStudents, setSelectedStudents] = useState([]);

//   const isUpdatingFromTable = useRef(false);

//   const queryParams = new URLSearchParams(location.search);

//   const roleId = queryParams.get("MNTCreatedRoleID");
//   const roleNameParam = queryParams.get("roleName");
//   const roleCodeParam = queryParams.get("roleCode");
//   const roleDescParam = queryParams.get("roleDescription");
//   const roleStatusParam = queryParams.get("status");
// const [roleStatus, setRoleStatus] = useState(roleStatusParam ? Number(roleStatusParam) : null);

//   useEffect(() => {
//     if (roleNameParam) setRoleName(roleNameParam);
//     if (roleCodeParam) setRoleCode(roleCodeParam);
//     if (roleDescParam) setDescription(roleDescParam);
//   }, []);

//   const fetchStudents = (searchKey) => {
//     if (!searchKey) {
//       setStudentOptions([]);
//       return;
//     }

//   const queryParams = new URLSearchParams(location.search);
//   const roleId = queryParams.get("MNTCreatedRoleID");

//   const params = new URLSearchParams();
//   params.append("client_branch_id", clientBranchNum);
//   params.append("search_key", searchKey);

//   fetch(`${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key?${params.toString()}`, {
//     headers: { Authorization: `Bearer ${accessToken}` },
//   })
//     .then((res) => res.json())
//     .then((json) => {
//       const data = json?.data || [];

//       const mapped = data.map((item) => ({
//         label: `${item.employee_name} (${item.staff_number}) - ${item.branch_name}`,
//         id: item.emp_id,
//         fullData: item,
//       }));

//       setStudentOptions(mapped);
//     })
//     .catch((err) => console.error("Error fetching users/groups:", err));
// };

//   const clientBranchNum = clientBranchId ? Number(clientBranchId) : null;
//   const normalizedSelectedBranches = Array.isArray(selectedBranches)
//     ? selectedBranches.map((id) => Number(id))
//     : [];

//   let branchIdsPayload = [];
//   if (normalizedSelectedBranches.length === 0) {
//     if (clientBranchNum !== null) branchIdsPayload = [clientBranchNum];
//   } else {
//     const set = new Set(normalizedSelectedBranches);
//     if (clientBranchNum !== null) set.add(clientBranchNum);
//     branchIdsPayload = Array.from(set);
//   }

//   useEffect(() => {
//     const resolvedClientId =
//       clientBranchId ||
//       (() => {
//         try {
//           const stored = localStorage.getItem("client_branch_id");
//           return stored ? Number(stored) : null;
//         } catch (e) {
//           return null;
//         }
//       })();

//     if (!resolvedClientId) {
//       console.debug("fetchBranches: waiting for clientBranchId to be available");
//       return;
//     }

//     const fetchBranches = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-branch-list?client_id=${resolvedClientId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const json = await res.json();

//         if (json && json.status === 200 && Array.isArray(json.data)) {
//           // normalize options
//           const opts = json.data.map((b) => ({
//             label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
//             id: b.branch_id,
//             disabled: Number(b.branch_id) === clientBranchNum,
//           }));
//           setBranchOptions(opts);
//         } else {
//           console.warn("fetchBranches: unexpected response", json);
//           setBranchOptions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching branches:", err);
//         setBranchOptions([]);
//       }
//     };

//     fetchBranches();
//   }, [clientBranchId, dataClient, clientBranchNum]);

//   const headers = [
//     "User ID",
//     "User/Group Name",
//     "Identifier",
//   ];

//   const tableData = (Array.isArray(selectedStudents) ? selectedStudents : [])
//     .map((id) => {
//       const opt = studentOptions.find((o) => o.id === id);
//       if (!opt || !opt.fullData) return null;

//       const d = opt.fullData;

//       return [
//         id,
//         d.user_name || "---",
//         d.identifier || "-",
//       ];
//     })
//     .filter(Boolean);

//   const handleTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromTable.current = true;
//     setSelectedStudents(newSelectedRows);
//     // Reset flag after state update
//     setTimeout(() => {
//       isUpdatingFromTable.current = false;
//     }, 0);
//   };

//   // Delete row handler
//   const handleDeleteRow = (rowId) => {
//     setStudentOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSelectedStudents((prev) => prev.filter((id) => id !== rowId));
//   };

//   const handleSave = async () => {
//     const queryParams = new URLSearchParams(location.search);
//     const roleId = queryParams.get("MNTCreatedRoleID");

//     if (!roleId) {
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Role ID is missing!</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     // Extract fullData for all selected students
//     const selectedFullData = studentOptions
//       .filter((item) => selectedStudents.includes(item.id))
//       .map((o) => o.fullData);

//     // Users = identifier === 1 or undefined
//     const user_id_list = selectedFullData
//       .filter((d) => d.identifier === 1)
//       .map((d) => d.emp_id);

//     // User Groups = identifier === 2
//     const user_group_id_list = selectedFullData
//       .filter((d) => d.identifier === 2)
//       .map((d) => d.emp_id);

//     // Default User Group = identifier === 2 && default_group === true
//     const default_user_group_id_list = selectedFullData
//       .filter((d) => d.identifier === 3)
//       .map((d) => d.emp_id);

//     const payload = {
//       role_id: Number(roleId),
//       user_name: userName || "system",
//       user_id_list,
//       user_group_id_list,
//       default_user_group_id_list,
//     };

//     console.log("FINAL PAYLOAD:", payload);

//     // SHOW LOADER
//     setIsMessageBoxVisible(true);
//     setActiveImg(InterogativeImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Updating role...</span>
//         </div>
//       </div>
//     );

//     try {
//       const res = await fetch(
//         `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const json = await res.json();

//       if (json.status === 200) {
//         setActiveImg(InterogativeImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>Role updated successfully!</span>
//             </div>
//           </div>
//         );
//       } else {
//         setActiveImg(ErrorImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{json.message || "Failed to update role!"}</span>
//             </div>
//           </div>
//         );
//       }
//     } catch (error) {
//       console.error("API Error:", error);
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Something went wrong!</span>
//           </div>
//         </div>
//       );
//     }
//   };

//   const updateRoleStatus = async (newStatus) => {
//     const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");

//     if (!roleId) return;

//     const payload = {
//       role_id: Number(roleId),
//       status: newStatus,
//       user_name: userName,
//     };

//     console.log("STATUS PAYLOAD:", payload);

//     setIsMessageBoxVisible(true);
//     setActiveImg(InterogativeImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>{newStatus === 1 ? "Activating role..." : "Deactivating role..."}</span>
//         </div>
//       </div>
//     );

//     try {
//       const res = await fetch(
//         `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const json = await res.json();
//       console.log("STATUS RESPONSE:", json);

//       if (json.status === 200) {
//         setRoleStatus(newStatus);
//         setActiveImg(InterogativeImg);

//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>
//                 Role {newStatus === 1 ? "activated" : "deactivated"} successfully!
//               </span>
//             </div>
//           </div>
//         );
//       } else {
//         setActiveImg(ErrorImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{json.message || "Operation failed!"}</span>
//             </div>
//           </div>
//         );
//       }
//     } catch (error) {
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Something went wrong!</span>
//           </div>
//         </div>
//       );
//     }
//   };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Assign User to Role</span>
//         {/* <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button
//             className="cr-cancel-btn"
//             style={{width: "140px"}}
//           >
//             DEACTIVATE
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div> */}
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>

//           {/* DEACTIVATE button when status = 1 */}
//           {roleStatus === 1 && (
//             <button
//               className="cr-cancel-btn"
//               style={{ width: "140px"}}
//               onClick={() => updateRoleStatus(0)}
//             >
//               DEACTIVATE
//             </button>
//           )}

//           {/* ACTIVATE button when status = 0 */}
//           {roleStatus === 0 && (
//             <button
//               className="cr-create-btn"
//               style={{ width: "140px"}}
//               onClick={() => updateRoleStatus(1)}
//             >
//               ACTIVATE
//             </button>
//           )}

//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>
//        <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>ROLE DETAILS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionRoleDetails}>
//             {isOpenRoleDetails ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenRoleDetails && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <FormInputs
//                     label="Role Name"
//                     type="text"
//                     required
//                     value={roleName}
//                     onChange={(e) => setRoleName(e.target.value)}
//                     disabled
//                   />
//                 </div>
//                 <div className="item2">
//                   <FormInputs
//                     label="Role Code"
//                     type="text"
//                     required
//                     value={roleCode}
//                     onChange={(e) => setRoleCode(e.target.value)}
//                     disabled
//                   />
//                 </div>
//                 <div className="item4-creaete-role-description" style={{ gridColumn: "1 / 3" }}>
//                   <FormInputs
//                     label="Description"
//                     type="textarea"
//                     className="create-role-description-field"
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                     required
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD USER/GROUP</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>
//         {isOpenShareBranch && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{padding: "20px 0px 20px 10px"}}>
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{ gridColumn: "1 / -1" }}>
//                   <DropdownWithPagination
//                     label="Add User/Group"
//                     width="40%"
//                     selected={selectedStudents}
//                     setSelected={setSelectedStudents}
//                     onSearchInputChange={fetchStudents}
//                     options={studentOptions}
//                     isRequired={false}
//                     showSelectAll={true}
//                     itemsPerPage={4}
//                   />
//                 </div>
//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headers}
//                     data={tableData}
//                     searchPlaceholder="Search user..."
//                     selectedRows={selectedStudents}
//                     setSelectedRows={handleTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRow}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UpdatedAssignToRole;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { FaUser } from "react-icons/fa";
// import { FaUserGroup } from "react-icons/fa6";

// function UpdatedAssignToRole({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [roleName, setRoleName] = useState("");
//   const [roleCode, setRoleCode] = useState("");
//   const [description, setDescription] = useState("");
//   const [isOpenRoleDetails, setIsOpenRoleDetails] = useState(true);
//   const toggleAccordionRoleDetails = () => setIsOpenRoleDetails(!isOpenRoleDetails);

//   const [branchOptions, setBranchOptions] = useState([]);
//   const [selectedBranches, setSelectedBranches] = useState([]);

//   const [initialAssignedOptions, setInitialAssignedOptions] = useState([]);
//   const [searchOptions, setSearchOptions] = useState([]);

//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const isUpdatingFromTable = useRef(false);

//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const toggleAccordionShareBranch = () => setIsOpenShareBranch(!isOpenShareBranch);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   const queryParams = new URLSearchParams(location.search);
//   const roleIdFromQuery = queryParams.get("MNTCreatedRoleID");
//   const roleNameParam = queryParams.get("roleName");
//   const roleCodeParam = queryParams.get("roleCode");
//   const roleDescParam = queryParams.get("roleDescription");
//   const roleStatusParam = queryParams.get("status");
//   const [roleStatus, setRoleStatus] = useState(roleStatusParam ? Number(roleStatusParam) : null);

//   useEffect(() => {
//     if (roleNameParam) setRoleName(roleNameParam);
//     if (roleCodeParam) setRoleCode(roleCodeParam);
//     if (roleDescParam) setDescription(roleDescParam);
//   }, [roleNameParam, roleCodeParam, roleDescParam]);

//   const clientBranchNum = clientBranchId ? Number(clientBranchId) : (() => {
//     try {
//       const stored = localStorage.getItem("client_branch_id");
//       return stored ? Number(stored) : null;
//     } catch (e) {
//       return null;
//     }
//   })();

//   useEffect(() => {
//     const resolvedClientId =
//       clientBranchId ||
//       (() => {
//         try {
//           const stored = localStorage.getItem("client_branch_id");
//           return stored ? Number(stored) : null;
//         } catch (e) {
//           return null;
//         }
//       })();

//     if (!resolvedClientId) {
//       console.debug("fetchBranches: waiting for clientBranchId to be available");
//       return;
//     }

//     const fetchBranches = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-branch-list?client_id=${resolvedClientId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const json = await res.json();

//         if (json && json.status === 200 && Array.isArray(json.data)) {
//           // normalize options
//           const opts = json.data.map((b) => ({
//             label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
//             id: b.branch_id,
//             disabled: Number(b.branch_id) === clientBranchNum,
//           }));
//           setBranchOptions(opts);
//         } else {
//           console.warn("fetchBranches: unexpected response", json);
//           setBranchOptions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching branches:", err);
//         setBranchOptions([]);
//       }
//     };

//     fetchBranches();
//   }, [clientBranchId, dataClient, clientBranchNum]);

//   useEffect(() => {
//     const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");
//     const resolvedClientBranch = clientBranchNum;

//     if (!roleId || !resolvedClientBranch) return;

//     const fetchPreAssignedUsers = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-app-users-by-role-id?role_id=${roleId}&client_branch_id=${resolvedClientBranch}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const json = await res.json();

//         if (json && json.status === 200 && Array.isArray(json.data)) {
//           // const mapped = json.data.map((item) => ({
//           //   id: item.user_group_id,
//           //   label: item.group_name,
//           //   fullData: {
//           //     emp_id: item.user_group_id,         // emp_id === user_group_id per your note
//           //     employee_name: item.group_name,     // group_name -> employee_name
//           //     identifier: item.identifier ?? 1,
//           //   },
//           // }));
//           const mapped = json.data.map((item) => {
//               let icon = "";
//               const identifier = item.identifier ?? 1;

//               if (identifier === 1) icon = <FaUser size={20}  style={{ marginRight: 6}} />;
//               else if (identifier === 2) icon = <FaUserGroup size={20}  style={{ marginRight: 6}} />;
//               else if (identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 6, color: "#6bce6e" }} />;

//               return {
//                 id: item.user_group_id,
//                 label: (
//                   <span style={{ display: "flex", alignItems: "center" }}>
//                     {icon} {item.group_name}
//                   </span>
//                 ),
//                 fullData: {
//                   emp_id: item.user_group_id,
//                   user_id: item.user_id !== "-" ? item.user_id : null,
//                   employee_name: item.group_name,
//                   identifier,
//                 },
//               };
//             });
//           setInitialAssignedOptions(mapped);
//           setSelectedStudents(mapped.map((o) => o.id));
//         }
//       } catch (err) {
//         console.error("Error fetching initial assigned users:", err);
//       }
//     };

//     fetchPreAssignedUsers();
//   }, [clientBranchNum, location.search]);

//   const fetchStudents = (searchKey) => {
//     if (!searchKey) {
//       setSearchOptions([]);
//       return;
//     }

//     if (!clientBranchNum) {
//       console.warn("fetchStudents: clientBranchNum not available yet.");
//       setSearchOptions([]);
//       return;
//     }

//     const params = new URLSearchParams();
//     params.append("client_branch_id", clientBranchNum);
//     params.append("search_key", searchKey);

//     fetch(
//       `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key?${params.toString()}`,
//       { headers: { Authorization: `Bearer ${accessToken}` } }
//     )
//       .then((res) => res.json())
//       .then((json) => {
//         const data = json?.data || [];

//         // const mapped = data.map((item) => ({
//         //   id: item.emp_id,
//         //   label: `${item.employee_name} (${item.staff_number || ""}) - ${item.branch_name || ""}`,
//         //   fullData: {
//         //     emp_id: item.emp_id,
//         //     employee_name: item.employee_name,
//         //     identifier: item.identifier,
//         //   },
//         // }));
//         const mapped = data.map((item) => {
//             let icon = "";
//             if (item.identifier === 1) icon = <FaUser size={20} style={{ marginRight: 6 }} />;
//             else if (item.identifier === 2) icon = <FaUserGroup size={20} style={{ marginRight: 6 }} />;
//             else if (item.identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 6, color: "#6bce6e" }} />;

//             return {
//               id: item.emp_id,
//               label: (
//                 <span style={{ display: "flex", alignItems: "center" }}>
//                   {icon} {item.employee_name} ({item.staff_number || ""}) - {item.branch_name || ""}
//                 </span>
//               ),
//               fullData: {
//                 emp_id: item.emp_id,
//                 employee_name: item.employee_name,
//                 identifier: item.identifier,
//               },
//             };
//           });

//         setSearchOptions(mapped);
//       })
//       .catch((err) => console.error("Error fetching users/groups:", err));
//   };

//   const studentOptions = (() => {
//     const merged = [...initialAssignedOptions];
//     searchOptions.forEach((item) => {
//       if (!merged.some((o) => o.id === item.id)) {
//         merged.push(item);
//       }
//     });
//     return merged;
//   })();

//   const tableData = (Array.isArray(selectedStudents) ? selectedStudents : [])
//     .map((id) => {
//       const opt = studentOptions.find((o) => o.id === id);
//       if (!opt || !opt.fullData) return null;

//       const d = opt.fullData;

//       // return [
//       //   d.emp_id,                                // User Group ID or Emp ID
//       //   d.employee_name || d.user_name || "---", // display name
//       //   d.identifier === 1 ? "User" : d.identifier === 2 ? "Group" : d.identifier === 3 ? "Default Group" : String(d.identifier || "-"),
//       // ];
//       let icon = "";
//         if (d.identifier === 1) icon = <FaUser size={20} style={{ marginRight: 4}} />;
//         else if (d.identifier === 2) icon = <FaUserGroup size={20} style={{ marginRight: 4}} />;
//         else if (d.identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 4}} />;

//         return [
//           d.emp_id,
//           <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//             {icon} {d.employee_name || d.user_name || "---"}
//           </span>,
//           d.identifier === 1 ? "User" :
//           d.identifier === 2 ? "Group" :
//           d.identifier === 3 ? "Default Group" :
//           String(d.identifier || "-"),
//         ];
//     })
//     .filter(Boolean);

//   const handleTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromTable.current = true;
//     setSelectedStudents(newSelectedRows);
//     setTimeout(() => {
//       isUpdatingFromTable.current = false;
//     }, 0);
//   };

//   const handleDeleteRow = (rowId) => {
//     setInitialAssignedOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSearchOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSelectedStudents((prev) => prev.filter((id) => id !== rowId));
//   };

//   const handleSave = async () => {
//     const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");
//     if (!selectedStudents || selectedStudents.length === 0) {
//       setActiveImg(ErrorImg);
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Please select at least one User or Group!</span>
//           </div>
//         </div>
//       );
//       return;
//     }

//     // Build selected fullData list by finding selected IDs in the merged options
//     const selectedFullData = (selectedStudents || [])
//       .map((id) => studentOptions.find((o) => o.id === id))
//       .filter(Boolean)
//       .map((o) => o.fullData);

//     // Users = identifier === 1 or undefined -> send emp_id (which for preassigned is user_group_id)
//     const user_id_list = selectedFullData
//       .filter((d) => d.identifier === 1 || d.identifier === undefined)
//       .map((d) => d.user_id ?? d.emp_id);

//     // User Groups = identifier === 2
//     const user_group_id_list = selectedFullData
//       .filter((d) => d.identifier === 2)
//       .map((d) => d.user_id ?? d.emp_id);

//     // Default User Group = identifier === 3
//     const default_user_group_id_list = selectedFullData
//       .filter((d) => d.identifier === 3)
//       .map((d) => d.user_id ?? d.emp_id);

//     const payload = {
//       role_id: Number(roleId),
//       user_name: userName,
//       user_id_list,
//       user_group_id_list,
//       default_user_group_id_list,
//     };

//     setIsMessageBoxVisible(true);
//     setActiveImg(InterogativeImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Updating role...</span>
//         </div>
//       </div>
//     );

//     try {
//       const res = await fetch(
//         `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const json = await res.json();

//       if (json.status === 200) {
//         setActiveImg(InterogativeImg);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Role updated successfully!</span>
//             </div>
//           </div>
//         );
//         setTimeout(() => {
//           window.location.reload();
//         }, 1200);
//       }  else {
//         setActiveImg(ErrorImg);
//         const errorMessage =
//           json.status === 500
//             ? "Internal Server Error! Please contact admin."
//             : json.message || "Failed to update role!";
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{errorMessage}</span>
//             </div>
//           </div>
//         );
//       }
//     } catch (error) {
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Something went wrong!</span>
//           </div>
//         </div>
//       );
//     }
//   };

//   const headers = ["User ID", "User/Group Name", "Identifier"];

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Assign User to Role</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>ROLE DETAILS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionRoleDetails}>
//             {isOpenRoleDetails ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenRoleDetails && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <FormInputs
//                     label="Role Name"
//                     type="text"
//                     required
//                     value={roleName}
//                     onChange={(e) => setRoleName(e.target.value)}
//                     disabled
//                   />
//                 </div>
//                 <div className="item2">
//                   <FormInputs
//                     label="Role Code"
//                     type="text"
//                     required
//                     value={roleCode}
//                     onChange={(e) => setRoleCode(e.target.value)}
//                     disabled
//                   />
//                 </div>
//                 <div className="item3">
//                   <FormInputs
//                     label="Status"
//                     type="text"
//                     value={roleStatus === 1 ? "Active" : "Inactive"}
//                     disabled
//                   />
//                 </div>
//                 <div className="item4-creaete-role-description" style={{ gridColumn: "1 / -1" }}>
//                   <FormInputs
//                     label="Description"
//                     type="textarea"
//                     className="create-role-description-field"
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                     required
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD USER/GROUP</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenShareBranch && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 0px" }}>
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{marginLeft: "20px"}}>
//                   <DropdownWithPagination
//                     label="Add User/Group"
//                     width="100%"
//                     selected={selectedStudents}
//                     setSelected={setSelectedStudents}
//                     onSearchInputChange={fetchStudents}
//                     options={studentOptions}
//                     isRequired={false}
//                     showSelectAll={false}
//                     itemsPerPage={4}
//                   />
//                 </div>

//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headers}
//                     data={tableData}
//                     searchPlaceholder="Search user..."
//                     selectedRows={selectedStudents}
//                     setSelectedRows={handleTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRow}
//                     hideIdColumn={true}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UpdatedAssignToRole;

// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
// import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
// import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
// import { FaUser } from "react-icons/fa";
// import { FaUserGroup } from "react-icons/fa6";

// function UpdatedAssignToRole({ dataClient, setMessageBox, messageBox, setIsMessageBoxVisible, setActiveImg }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [selectedSession, setSelectedSession] = useState(null);
//   const [roleName, setRoleName] = useState("");
//   const [roleCode, setRoleCode] = useState("");
//   const [description, setDescription] = useState("");
//   const [isOpenRoleDetails, setIsOpenRoleDetails] = useState(true);
//   const toggleAccordionRoleDetails = () => setIsOpenRoleDetails(!isOpenRoleDetails);

//   const [branchOptions, setBranchOptions] = useState([]);
//   const [selectedBranches, setSelectedBranches] = useState([]);

//   const [searchOptions, setSearchOptions] = useState([]);
//   const [allSelectedUsersData, setAllSelectedUsersData] = useState([]); // NEW: Store all selected users data

//   const [selectedStudents, setSelectedStudents] = useState([]);
//   const isUpdatingFromTable = useRef(false);

//   const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
//   const toggleAccordionShareBranch = () => setIsOpenShareBranch(!isOpenShareBranch);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
//   const accessToken = localStorage.getItem("other");

//   const queryParams = new URLSearchParams(location.search);
//   const roleIdFromQuery = queryParams.get("MNTCreatedRoleID");
//   const roleNameParam = queryParams.get("roleName");
//   const roleCodeParam = queryParams.get("roleCode");
//   const roleDescParam = queryParams.get("roleDescription");
//   const roleStatusParam = queryParams.get("status");
//   const [roleStatus, setRoleStatus] = useState(roleStatusParam ? Number(roleStatusParam) : null);

//   useEffect(() => {
//     if (roleNameParam) setRoleName(roleNameParam);
//     if (roleCodeParam) setRoleCode(roleCodeParam);
//     if (roleDescParam) setDescription(roleDescParam);
//   }, [roleNameParam, roleCodeParam, roleDescParam]);

//   const clientBranchNum = clientBranchId ? Number(clientBranchId) : (() => {
//     try {
//       const stored = localStorage.getItem("client_branch_id");
//       return stored ? Number(stored) : null;
//     } catch (e) {
//       return null;
//     }
//   })();

//   useEffect(() => {
//     const resolvedClientId =
//       clientBranchId ||
//       (() => {
//         try {
//           const stored = localStorage.getItem("client_branch_id");
//           return stored ? Number(stored) : null;
//         } catch (e) {
//           return null;
//         }
//       })();

//     if (!resolvedClientId) {
//       console.debug("fetchBranches: waiting for clientBranchId to be available");
//       return;
//     }

//     const fetchBranches = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-branch-list?client_id=${resolvedClientId}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         const json = await res.json();

//         if (json && json.status === 200 && Array.isArray(json.data)) {
//           const opts = json.data.map((b) => ({
//             label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
//             id: b.branch_id,
//             disabled: Number(b.branch_id) === clientBranchNum,
//           }));
//           setBranchOptions(opts);
//         } else {
//           console.warn("fetchBranches: unexpected response", json);
//           setBranchOptions([]);
//         }
//       } catch (err) {
//         console.error("Error fetching branches:", err);
//         setBranchOptions([]);
//       }
//     };

//     fetchBranches();
//   }, [clientBranchId, dataClient, clientBranchNum]);

//   // Fetch pre-assigned users and store them in allSelectedUsersData
//   useEffect(() => {
//     const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");
//     const resolvedClientBranch = clientBranchNum;

//     if (!roleId || !resolvedClientBranch) return;

//     const fetchPreAssignedUsers = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const res = await fetch(
//           `${FULL_API_BASE_URL}/get-app-users-by-role-id?role_id=${roleId}&client_branch_id=${resolvedClientBranch}`,
//           { headers: { Authorization: `Bearer ${token}` } }
//         );

//         const json = await res.json();

//         if (json && json.status === 200 && Array.isArray(json.data)) {
//           const mapped = json.data.map((item) => {
//             let icon = "";
//             const identifier = item.identifier ?? 1;

//             if (identifier === 1) icon = <FaUser size={20} style={{ marginRight: 6 }} />;
//             else if (identifier === 2) icon = <FaUserGroup size={20} style={{ marginRight: 6 }} />;
//             else if (identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 6, color: "#6bce6e" }} />;

//             return {
//               id: item.user_group_id,
//               label: (
//                 <span style={{ display: "flex", alignItems: "center" }}>
//                   {icon} {item.group_name}
//                 </span>
//               ),
//               // fullData: {
//               //   emp_id: item.user_group_id,
//               //   user_id: item.user_id !== "-" ? item.user_id : null,
//               //   employee_name: item.group_name,
//               //   identifier,
//               // },
//                fullData: {
//                 emp_id: item.user_group_id,
//                 user_id: item.user_id !== "-" ? item.user_id : null,
//                 employee_name: item.group_name,
//                 emp_name: item.employee_name !== "-" ? item.employee_name : "-",
//                 staff_number: item.staff_number !== "-" ? item.staff_number : "-",
//                 designation_name: item.designation_name !== "-" ? item.designation_name : "-",
//                 department_name: item.department_name !== "-" ? item.department_name : "-",
//                 branch_name: item.branch_name !== "-" ? item.branch_name : "-",
//                 status: item.status !== "-" ? item.status : "-",
//                 user_count: item.user_count || "-",
//                 identifier,
//               },
//             };
//           });

//           // Store in allSelectedUsersData
//           setAllSelectedUsersData(mapped);
//           setSelectedStudents(mapped.map((o) => o.id));
//         }
//       } catch (err) {
//         console.error("Error fetching initial assigned users:", err);
//       }
//     };

//     fetchPreAssignedUsers();
//   }, [clientBranchNum, location.search]);

//   // Update selected users and store their data
//   useEffect(() => {
//     if (!isUpdatingFromTable.current && searchOptions.length > 0) {
//       // When dropdown selection changes, update stored data
//       const newlySelectedUsers = searchOptions.filter(opt =>
//         selectedStudents.includes(opt.id)
//       );

//       setAllSelectedUsersData(prev => {
//         const existingIds = new Set(prev.map(s => s.id));
//         const toAdd = newlySelectedUsers.filter(s => !existingIds.has(s.id));
//         return [...prev, ...toAdd];
//       });
//     }
//   }, [selectedStudents]);

//   // const fetchStudents = (searchKey) => {
//   //   if (!searchKey) {
//   //     setSearchOptions([]);
//   //     return;
//   //   }

//   //   if (!clientBranchNum) {
//   //     console.warn("fetchStudents: clientBranchNum not available yet.");
//   //     setSearchOptions([]);
//   //     return;
//   //   }

//   //   const params = new URLSearchParams();
//   //   params.append("client_branch_id", clientBranchNum);
//   //   params.append("search_key", searchKey);

//   //   fetch(
//   //     `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key?${params.toString()}`,
//   //     { headers: { Authorization: `Bearer ${accessToken}` } }
//   //   )
//   //     .then((res) => res.json())
//   //     .then((json) => {
//   //       const data = json?.data || [];

//   //       const mapped = data.map((item) => {
//   //         let icon = "";
//   //         if (item.identifier === 1) icon = <FaUser size={20} style={{ marginRight: 6 }} />;
//   //         else if (item.identifier === 2) icon = <FaUserGroup size={20} style={{ marginRight: 6 }} />;
//   //         else if (item.identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 6, color: "#6bce6e" }} />;

//   //         return {
//   //           id: item.emp_id,
//   //           label: (
//   //             <span style={{ display: "flex", alignItems: "center" }}>
//   //               {icon} {item.employee_name} ({item.staff_number || ""}) - {item.branch_name || ""}
//   //             </span>
//   //           ),
//   //           // fullData: {
//   //           //   emp_id: item.emp_id,
//   //           //   user_id: item.user_id,
//   //           //   employee_name: item.employee_name,
//   //           //   identifier: item.identifier,
//   //           // },
//   //           fullData: {
//   //             emp_id: item.emp_id,
//   //             user_id: item.user_id,
//   //             employee_name: item.employee_name,
//   //             emp_name: item.employee_name || "-",
//   //             staff_number: item.staff_number || "-",
//   //             designation_name: item.designation_name || "-",
//   //             department_name: item.department_name || "-",
//   //             branch_name: item.branch_name || "-",
//   //             status: item.status || "-",
//   //             user_count: item.user_count || "-",
//   //             identifier: item.identifier,
//   //           },
//   //         };
//   //       });

//   //       setSearchOptions(mapped);
//   //     })
//   //     .catch((err) => console.error("Error fetching users/groups:", err));
//   // };

//   // Merge options: all selected users + current search results

//   // ============================================
// // REPLACE YOUR fetchStudents FUNCTION WITH THIS:
// // ============================================

//   const fetchStudents = (searchKey) => {
//     if (!searchKey) {
//       setSearchOptions([]);
//       return;
//     }

//     if (!clientBranchNum) {
//       console.warn("fetchStudents: clientBranchNum not available yet.");
//       setSearchOptions([]);
//       return;
//     }

//     const params = new URLSearchParams();
//     params.append("client_branch_id", clientBranchNum);
//     params.append("search_key", searchKey);

//     fetch(
//       `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key?${params.toString()}`,
//       { headers: { Authorization: `Bearer ${accessToken}` } }
//     )
//       .then((res) => res.json())
//       .then((json) => {
//         const data = json?.data || [];

//         const mapped = data.map((item) => {
//           let icon = "";
//           if (item.identifier === 1) icon = <FaUser size={20} style={{ marginRight: 6 }} />;
//           else if (item.identifier === 2) icon = <FaUserGroup size={20} style={{ marginRight: 6 }} />;
//           else if (item.identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 6, color: "#6bce6e" }} />;

//           return {
//             id: item.emp_id,
//             label: (
//               <span style={{ display: "flex", alignItems: "center" }}>
//                 {icon} {item.user_name} ({item.staff_number || ""}) - {item.branch_name || ""}
//               </span>
//             ),
//             fullData: {
//               emp_id: item.emp_id,
//               user_id: item.user_id,
//               employee_name: item.employee_name,
//               emp_name: item.employee_name || "-",
//               staff_number: item.staff_number || "-",
//               designation_name: item.designation_name || "-",
//               department_name: item.department_name || "-",
//               branch_name: item.branch_name || "-",
//               status: item.status || "-",
//               user_count: item.user_count || "-",
//               identifier: item.identifier,
//             },
//           };
//         });

//         // CRITICAL: Put new search results FIRST, then existing options
//         // This ensures unselected items appear first, selected items appear last
//         setSearchOptions((prev = []) => {
//           const map = new Map();
//           // Add new search results first (these will be mostly unselected)
//           mapped.forEach((n) => map.set(String(n.id), n));
//           // Then add previous options that aren't duplicates (these include selected ones)
//           prev.forEach((p) => {
//             if (!map.has(String(p.id))) map.set(String(p.id), p);
//           });
//           return Array.from(map.values());
//         });
//       })
//       .catch((err) => console.error("Error fetching users/groups:", err));
//   };

//   const studentOptions = (() => {
//     const map = new Map();

//     // Add search options first (unselected items will be here)
//     searchOptions.forEach((item) => {
//       map.set(String(item.id), item);
//     });

//     // Then add selected users that aren't already in search results
//     allSelectedUsersData.forEach((item) => {
//       if (!map.has(String(item.id))) {
//         map.set(String(item.id), item);
//       }
//     });

//     return Array.from(map.values());
//   })();

//   // const studentOptions = (() => {
//   //   const merged = [...allSelectedUsersData];
//   //   searchOptions.forEach((item) => {
//   //     if (!merged.some((o) => o.id === item.id)) {
//   //       merged.push(item);
//   //     }
//   //   });
//   //   return merged;
//   // })();

//   // Build table data from allSelectedUsersData
//   const tableData = (Array.isArray(selectedStudents) ? selectedStudents : [])
//     .map((id) => {
//       const opt = allSelectedUsersData.find((o) => o.id === id);
//       if (!opt || !opt.fullData) return null;

//       const d = opt.fullData;

//       let icon = "";
//       if (d.identifier === 1) icon = <FaUser size={20} style={{ marginRight: 4 }} />;
//       else if (d.identifier === 2) icon = <FaUserGroup size={20} style={{ marginRight: 4 }} />;
//       else if (d.identifier === 3) icon = <FaUserGroup size={20} style={{ marginRight: 4 }} />;

//       return [
//         d.emp_id,
//         <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//           {icon} {d.employee_name || d.user_name || "---"}
//         </span>,
//         // d.identifier === 1 ? "User" :
//         // d.identifier === 2 ? "Group" :
//         // d.identifier === 3 ? "Default Group" :
//         // String(d.identifier || "-"),
//           d.emp_name || "-",
//           d.staff_number || "-",
//           d.designation_name || "-",
//           d.department_name || "-",
//           d.branch_name || "-",
//           d.status || "-",
//           d.user_count || "-",
//           d.identifier === 1 ? "User" :
//           d.identifier === 2 ? "Group" :
//           d.identifier === 3 ? "Default Group" :
//           String(d.identifier || "-"),
//         ];
//     })
//     .filter(Boolean);

//   const handleTableRowSelection = (newSelectedRows) => {
//     isUpdatingFromTable.current = true;
//     setSelectedStudents(newSelectedRows);
//     setTimeout(() => {
//       isUpdatingFromTable.current = false;
//     }, 0);
//   };

//   const handleDeleteRow = (rowId) => {
//     setAllSelectedUsersData((prev) => prev.filter((o) => o.id !== rowId));
//     setSearchOptions((prev) => prev.filter((o) => o.id !== rowId));
//     setSelectedStudents((prev) => prev.filter((id) => id !== rowId));
//   };

//   const handleSave = async () => {
//     const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");

//     if (!selectedStudents || selectedStudents.length === 0) {
//       setIsMessageBoxVisible(true);
//       setMessageBox(
//          <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Please select at least one User or Group!</span>
//           </div>
//         </div>
//         );
//       setActiveImg(ErrorImg);
//       return;
//     }

//     // Build selected fullData list from allSelectedUsersData
//     // This now includes BOTH pre-assigned users AND newly added users
//     const selectedFullData = (selectedStudents || [])
//       .map((id) => allSelectedUsersData.find((o) => o.id === id))
//       .filter(Boolean)
//       .map((o) => o.fullData);

//     // Separate by identifier type
//     // Users = identifier === 1 -> send user_id
//     const user_id_list = selectedFullData
//       .filter((d) => d.identifier === 1)
//       .map((d) => d.user_id)
//       .filter(Boolean); // Filter out null/undefined user_ids

//     // User Groups = identifier === 2 -> send emp_id
//     const user_group_id_list = selectedFullData
//       .filter((d) => d.identifier === 2)
//       .map((d) => d.emp_id);

//     // Default User Group = identifier === 3 -> send emp_id
//     const default_user_group_id_list = selectedFullData
//       .filter((d) => d.identifier === 3)
//       .map((d) => d.emp_id);

//     const payload = {
//       role_id: Number(roleId),
//       user_name: userName,
//       user_id_list,
//       user_group_id_list,
//       default_user_group_id_list,
//     };

//     console.log("Payload being sent:", payload);

//     setIsMessageBoxVisible(true);

//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <div className="loader-tc"></div>
//           <span>Updating role...</span>
//         </div>
//       </div>
//     );
//     setActiveImg(InterogativeImg);

//     try {
//       const res = await fetch(
//         `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         }
//       );

//       const json = await res.json();

//       if (json.status === 200) {
//         setIsMessageBoxVisible(true);
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <div className="loader-tc"></div>
//               <span>Role updated successfully!</span>
//             </div>
//           </div>
//         );
//         setActiveImg(InterogativeImg);
//         setTimeout(() => {
//           window.location.reload();
//         }, 1200);
//       } else {
//         setActiveImg(ErrorImg);
//         const errorMessage =
//           json.status === 500
//             ? "Internal Server Error! Please contact admin."
//             : json.message || "Failed to update role!";
//         setMessageBox(
//           <div className="Container-messageBOX">
//             <div className="messagebox-insider1">
//               <span>{errorMessage}</span>
//             </div>
//           </div>
//         );
//       }
//     } catch (error) {
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>Something went wrong!</span>
//           </div>
//         </div>
//       );
//     }
//   };

//   //  const headers = ["User ID", "User/Group Name", "Identifier"];
//   const headers = [
//     "User ID",
//     "User/Group Name",
//     "Employee Name",
//     "Staff Number",
//     "Designation",
//     "Department",
//     "Branch",
//     "Status",
//     "User Count",
//     "Identifier"
//   ];

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">Assign User to Role</span>
//         <div className="cr-header-btn-container">
//           <button
//             className="cr-cancel-btn"
//             onClick={() => navigate("/create_role_dashboard")}
//           >
//             CANCEL
//           </button>
//           <button className="cr-create-btn" onClick={handleSave}>
//             SAVE
//           </button>
//         </div>
//       </div>

//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header">
//             <label>ROLE DETAILS</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionRoleDetails}>
//             {isOpenRoleDetails ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenRoleDetails && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del">
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1">
//                   <FormInputs
//                     label="Role Name"
//                     type="text"
//                     required
//                     value={roleName}
//                     onChange={(e) => setRoleName(e.target.value)}
//                     disabled
//                   />
//                 </div>
//                 <div className="item2">
//                   <FormInputs
//                     label="Role Code"
//                     type="text"
//                     required
//                     value={roleCode}
//                     onChange={(e) => setRoleCode(e.target.value)}
//                     disabled
//                   />
//                 </div>
//                 <div className="item3">
//                   <FormInputs
//                     label="Status"
//                     type="text"
//                     value={roleStatus === 1 ? "Active" : "Inactive"}
//                     disabled
//                   />
//                 </div>
//                 <div className="item4-creaete-role-description" style={{ gridColumn: "1 / -1" }}>
//                   <FormInputs
//                     label="Description"
//                     type="textarea"
//                     className="create-role-description-field"
//                     value={description}
//                     onChange={(e) => setDescription(e.target.value)}
//                     required
//                     disabled
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <div className="ques-paper-del" style={{ marginTop: "20px" }}>
//         <div className="personal-header">
//           <div className="header">
//             <label>ADD USER/GROUP</label>
//           </div>
//           <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
//             {isOpenShareBranch ? <div className="minus"></div> : <div className="plus">+</div>}
//           </div>
//         </div>

//         {isOpenShareBranch && (
//           <div className="accordion-content">
//             <div className="select-assign-test-container-ques-pap-del" style={{ padding: "20px 0px 20px 0px" }}>
//               <div className="grid-container-ques-paper-del">
//                 <div className="item1" style={{marginLeft: "20px"}}>
//                   <DropdownWithPagination
//                     label="Add User/Group"
//                     width="100%"
//                     selected={selectedStudents}
//                     setSelected={setSelectedStudents}
//                     onSearchInputChange={fetchStudents}
//                     options={studentOptions}
//                     isRequired={false}
//                     showSelectAll={false}
//                     itemsPerPage={4}
//                     placeholder="Type to search users/groups..."
//                   />
//                 </div>

//                 <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
//                   <TableWithCrossStudentGroup
//                     headers={headers}
//                     data={tableData}
//                     searchPlaceholder="Search user..."
//                     selectedRows={selectedStudents}
//                     setSelectedRows={handleTableRowSelection}
//                     renderQuestionText={(text) => text}
//                     renderQuestionTextModel={(text) => text}
//                     expandedStates={{}}
//                     toggleImage={() => {}}
//                     pageType="userEdit"
//                     onRowLinkClick={(row) => console.log("Row clicked:", row)}
//                     filterConfig={{}}
//                     handleDeleteRow={handleDeleteRow}
//                     hideIdColumn={true}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default UpdatedAssignToRole;

import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";
import DropdownWithPagination from "../../StudentGrouph/DropdownWithPagination";
import TableWithCrossStudentGroup from "../../StudentGrouph/TableWithCrossStudentGroup";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import InterogativeImg from "../../../Assets/Images/CommanImages/Interogative.png";
import { FaUser } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";

function UpdatedAssignToRole({
  dataClient,
  setMessageBox,
  messageBox,
  setIsMessageBoxVisible,
  setActiveImg,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [roleName, setRoleName] = useState("");
  const [roleCode, setRoleCode] = useState("");
  const [description, setDescription] = useState("");
  const [isOpenRoleDetails, setIsOpenRoleDetails] = useState(true);
  const toggleAccordionRoleDetails = () =>
    setIsOpenRoleDetails(!isOpenRoleDetails);

  // Branches & selection
  const [branchOptions, setBranchOptions] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  // Search + selection data
  const [searchOptions, setSearchOptions] = useState([]);
  const [allSelectedUsersData, setAllSelectedUsersData] = useState([]); // canonical stored options with fullData
  const [selectedStudents, setSelectedStudents] = useState([]); // array of string ids
  const isUpdatingFromTable = useRef(false);

  // Share branch accordion
  const [isOpenShareBranch, setIsOpenShareBranch] = useState(true);
  const toggleAccordionShareBranch = () =>
    setIsOpenShareBranch(!isOpenShareBranch);

  // client / auth info
  const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || null;
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;
  const accessToken = localStorage.getItem("other");

  // role params from query
  const queryParams = new URLSearchParams(location.search);
  const roleIdFromQuery = queryParams.get("MNTCreatedRoleID");
  const roleNameParam = queryParams.get("roleName");
  const roleCodeParam = queryParams.get("roleCode");
  const roleDescParam = queryParams.get("roleDescription");
  const roleStatusParam = queryParams.get("status");

  const [roleStatus, setRoleStatus] = useState(() => {
    if (!roleStatusParam) return null;
    if (roleStatusParam === "Active") return 1;
    if (roleStatusParam === "Inactive") return 0;
    return Number(roleStatusParam);
  });

  useEffect(() => {
    if (roleNameParam) setRoleName(roleNameParam);
    if (roleCodeParam) setRoleCode(roleCodeParam);
    if (roleDescParam) setDescription(roleDescParam);
  }, [roleNameParam, roleCodeParam, roleDescParam]);

  // resolve client branch number (fallback to localStorage)
  const clientBranchNum = clientBranchId
    ? Number(clientBranchId)
    : (() => {
        try {
          const stored = localStorage.getItem("client_branch_id");
          return stored ? Number(stored) : null;
        } catch (e) {
          return null;
        }
      })();

  // helper: canonical id selection (emp_id preferred, else user_group_id, else user_id)
  const canonicalIdFor = (item = {}) => {
    if (
      item.emp_id &&
      String(item.emp_id) !== "-" &&
      String(item.emp_id) !== "null"
    )
      return String(item.emp_id);
    if (
      item.user_group_id &&
      String(item.user_group_id) !== "-" &&
      String(item.user_group_id) !== "null"
    )
      return String(item.user_group_id);
    if (
      item.user_id &&
      String(item.user_id) !== "-" &&
      String(item.user_id) !== "null"
    )
      return String(item.user_id);
    // fallback to a composite key to avoid collisions (shouldn't usually be needed)
    return String(
      item.emp_id ?? item.user_group_id ?? item.user_id ?? Math.random()
    );
  };

  // Fetch branches
  useEffect(() => {
    const resolvedClientId =
      clientBranchId ||
      (() => {
        try {
          const stored = localStorage.getItem("client_branch_id");
          return stored ? Number(stored) : null;
        } catch (e) {
          return null;
        }
      })();

    if (!resolvedClientId) {
      console.debug(
        "fetchBranches: waiting for clientBranchId to be available"
      );
      return;
    }

    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem("other");
        const res = await fetch(
          `${FULL_API_BASE_URL}/get-branch-list?client_id=${resolvedClientId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const json = await res.json();

        if (json && json.status === 200 && Array.isArray(json.data)) {
          const opts = json.data.map((b) => ({
            label: `${b.branch_name} / ${b.city_name} / ${b.state_name}`,
            id: b.branch_id,
            disabled: Number(b.branch_id) === clientBranchNum,
          }));
          setBranchOptions(opts);
        } else {
          console.warn("fetchBranches: unexpected response", json);
          setBranchOptions([]);
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
        setBranchOptions([]);
      }
    };

    fetchBranches();
  }, [clientBranchId, dataClient, clientBranchNum]);

  // Fetch pre-assigned users/groups and normalize them (handles identifier 1/2/3)
  useEffect(() => {
    const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");
    const resolvedClientBranch = clientBranchNum;

    if (!roleId || !resolvedClientBranch) return;

    const fetchPreAssignedUsers = async () => {
      try {
        const token = localStorage.getItem("other");
        const res = await fetch(
          `${FULL_API_BASE_URL}/get-app-users-by-role-id?role_id=${roleId}&client_branch_id=${resolvedClientBranch}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const json = await res.json();

        if (json && json.status === 200 && Array.isArray(json.data)) {
          // Map each item to consistent shape:
          const mapped = json.data.map((item) => {
            const identifier = item.identifier ?? 1;
            let icon = "";
            if (identifier === 1)
              icon = <FaUser size={20} style={{ marginRight: 6 }} />;
            else if (identifier === 2 || identifier === 3)
              icon = <FaUserGroup size={20} style={{ marginRight: 6 }} />;

            const id = canonicalIdFor(item);

            // pick display names: group_name if present else user_name; employee_name if present
            const groupName =
              item.group_name && String(item.group_name) !== "-"
                ? item.group_name
                : null;
            const userName =
              item.user_name && String(item.user_name) !== "-"
                ? item.user_name
                : null;
            const employeeName =
              item.employee_name && String(item.employee_name) !== "-"
                ? item.employee_name
                : null;

            const displayName = groupName || userName || employeeName || "-";

            return {
              id,
              label: (
                <span style={{ display: "flex", alignItems: "center" }}>
                  {icon} {displayName}
                </span>
              ),
              fullData: {
                id,
                // include both group_name and user_name explicitly for downstream use
                group_name: groupName || "-",
                user_name: userName || "-",
                employee_name: employeeName || "-",
                emp_id:
                  item.emp_id && String(item.emp_id) !== "-"
                    ? item.emp_id
                    : null,
                user_group_id:
                  item.user_group_id && String(item.user_group_id) !== "-"
                    ? item.user_group_id
                    : null,
                user_id:
                  item.user_id && String(item.user_id) !== "-"
                    ? item.user_id
                    : null,
                staff_number:
                  item.staff_number && String(item.staff_number) !== "-"
                    ? item.staff_number
                    : "-",
                designation_name:
                  item.designation_name && String(item.designation_name) !== "-"
                    ? item.designation_name
                    : "-",
                department_name:
                  item.department_name && String(item.department_name) !== "-"
                    ? item.department_name
                    : "-",
                branch_name:
                  item.branch_name && String(item.branch_name) !== "-"
                    ? item.branch_name
                    : "-",
                status:
                  item.status && String(item.status) !== "-"
                    ? item.status
                    : "-",
                user_count: item.user_count || "-",
                identifier,
              },
            };
          });

          setAllSelectedUsersData(mapped);
          setSelectedStudents(mapped.map((o) => o.id));
        }
      } catch (err) {
        console.error("Error fetching initial assigned users:", err);
      }
    };

    fetchPreAssignedUsers();
  }, [clientBranchNum, location.search]);

  // Update stored data from dropdown selection when not updating from table
  useEffect(() => {
    if (!isUpdatingFromTable.current && searchOptions.length > 0) {
      // When dropdown selection changes, update stored data
      const newlySelectedUsers = searchOptions.filter((opt) =>
        selectedStudents.map(String).includes(String(opt.id))
      );

      setAllSelectedUsersData((prev) => {
        const existingIds = new Set(prev.map((s) => String(s.id)));
        const toAdd = newlySelectedUsers.filter(
          (s) => !existingIds.has(String(s.id))
        );
        return [...prev, ...toAdd];
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStudents]);

  // Fetch students/groups on search input (with identifier ===1 user_id check applied)
  const fetchStudents = (searchKey) => {
    if (!searchKey) {
      setSearchOptions([]);
      return;
    }

    if (!clientBranchNum) {
      console.warn("fetchStudents: clientBranchNum not available yet.");
      setSearchOptions([]);
      return;
    }

    const params = new URLSearchParams();
    params.append("client_branch_id", clientBranchNum);
    params.append("search_key", searchKey);

    fetch(
      `${FULL_API_BASE_URL}/get-user-n-user-groups-for-role-by-search-key?${params.toString()}`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
      .then((res) => res.json())
      .then((json) => {
        const data = json?.data || [];

        // FILTER: For identifier === 1 (users), only keep items with a valid user_id
        const filtered = data.filter((item) => {
          if (item.identifier === 1) {
            // Accept only when user_id is present and not a "-" placeholder
            return item.user_id && String(item.user_id) !== "-";
          }
          return true;
        });

        const mapped = filtered.map((item) => {
          const identifier = item.identifier ?? 1;
          let icon = "";
          if (identifier === 1)
            icon = <FaUser size={20} style={{ marginRight: 6 }} />;
          else if (identifier === 2 || identifier === 3)
            icon = <FaUserGroup size={20} style={{ marginRight: 6 }} />;

          const id = canonicalIdFor(item);

          const groupName =
            item.group_name && String(item.group_name) !== "-"
              ? item.group_name
              : null;
          const userName =
            item.user_name && String(item.user_name) !== "-"
              ? item.user_name
              : null;
          const employeeName =
            item.employee_name && String(item.employee_name) !== "-"
              ? item.employee_name
              : null;
          const displayName = groupName || userName || employeeName || "-";

          return {
            id,
            label: (
              <span style={{ display: "flex", alignItems: "center" }}>
                {icon} {displayName} ({item.staff_number || ""}) -{" "}
                {item.branch_name || ""}
              </span>
            ),
            fullData: {
              id,
              group_name: groupName || "-",
              user_name: userName || "-",
              employee_name: employeeName || "-",
              emp_id:
                item.emp_id && String(item.emp_id) !== "-" ? item.emp_id : null,
              user_group_id:
                item.user_group_id && String(item.user_group_id) !== "-"
                  ? item.user_group_id
                  : null,
              user_id:
                item.user_id && String(item.user_id) !== "-"
                  ? item.user_id
                  : null,
              staff_number: item.staff_number || "-",
              designation_name: item.designation_name || "-",
              department_name: item.department_name || "-",
              branch_name: item.branch_name || "-",
              status: item.status || "-",
              user_count: item.user_count || "-",
              identifier: item.identifier,
            },
          };
        });

        // Put new search results first, preserve previously known options (including selected)
        setSearchOptions((prev = []) => {
          const map = new Map();
          mapped.forEach((n) => map.set(String(n.id), n));
          prev.forEach((p) => {
            if (!map.has(String(p.id))) map.set(String(p.id), p);
          });
          return Array.from(map.values());
        });
      })
      .catch((err) => console.error("Error fetching users/groups:", err));
  };

  // Combine searchOptions and allSelectedUsersData into studentOptions (search results first)
  const studentOptions = useMemo(() => {
    const map = new Map();
    // Add search options first
    searchOptions.forEach((item) => {
      map.set(String(item.id), item);
    });
    // Then add selected ones not already present
    allSelectedUsersData.forEach((item) => {
      if (!map.has(String(item.id))) {
        map.set(String(item.id), item);
      }
    });
    return Array.from(map.values());
  }, [searchOptions, allSelectedUsersData]);

  // Build table data: ensure User/Group Name uses group_name or user_name, and Employee Name uses employee_name
  const tableData = useMemo(() => {
    return (Array.isArray(selectedStudents) ? selectedStudents : [])
      .map((id) => {
        const opt = allSelectedUsersData.find(
          (o) => String(o.id) === String(id)
        );
        if (!opt || !opt.fullData) return null;

        const d = opt.fullData;

        let icon = "";
        if (d.identifier === 1)
          icon = <FaUser size={20} style={{ marginRight: 4 }} />;
        else icon = <FaUserGroup size={20} style={{ marginRight: 4 }} />;

        // Prefer group_name for group items; fall back to user_name
        const userGroupDisplay =
          d.group_name && String(d.group_name) !== "-"
            ? d.group_name
            : d.user_name;

        return [
          // User ID column (hidden by hideIdColumn)
          d.emp_id ?? d.user_group_id ?? d.user_id ?? "-",
          <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {icon} {userGroupDisplay || "---"}
          </span>, // User/Group Name
          d.employee_name || "-", // Employee Name (explicit)
          d.staff_number || "-",
          d.designation_name || "-",
          d.department_name || "-",
          d.branch_name || "-",
          d.status || "-",
          d.user_count || "-",
          d.identifier === 1
            ? "User"
            : d.identifier === 2
            ? "Group"
            : d.identifier === 3
            ? "Default Group"
            : String(d.identifier || "-"),
        ];
      })
      .filter(Boolean);
  }, [selectedStudents, allSelectedUsersData]);

  // Selection from table -> normalize to string ids
  const handleTableRowSelection = (newSelectedRows) => {
    isUpdatingFromTable.current = true;
    const normalized = (
      Array.isArray(newSelectedRows) ? newSelectedRows : []
    ).map(String);
    setSelectedStudents(normalized);
    // microtask allow other effects to notice origin
    setTimeout(() => {
      isUpdatingFromTable.current = false;
    }, 0);
  };

  const handleDeleteRow = (rowId) => {
    const idStr = String(rowId);
    setAllSelectedUsersData((prev) =>
      prev.filter((o) => String(o.id) !== idStr)
    );
    setSearchOptions((prev) => prev.filter((o) => String(o.id) !== idStr));
    setSelectedStudents((prev) => prev.filter((id) => String(id) !== idStr));
  };

  // Save handler (build payload and call API)
  const handleSave = async () => {
    const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");

    if (!selectedStudents || selectedStudents.length === 0) {
      setIsMessageBoxVisible(true);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Please select at least one User or Group!</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      return;
    }

    // Build selected fullData list from allSelectedUsersData
    const selectedFullData = (selectedStudents || [])
      .map((id) =>
        allSelectedUsersData.find((o) => String(o.id) === String(id))
      )
      .filter(Boolean)
      .map((o) => o.fullData);

    // Separate by identifier type: users send user_id; groups/default groups send emp_id/user_group_id
    const user_id_list = selectedFullData
      .filter((d) => d.identifier === 1)
      .map((d) => d.user_id)
      .filter(Boolean);

    const user_group_id_list = selectedFullData
      .filter((d) => d.identifier === 2)
      .map((d) => d.user_group_id || d.emp_id)
      .filter(Boolean);

    const default_user_group_id_list = selectedFullData
      .filter((d) => d.identifier === 3)
      .map((d) => d.user_group_id || d.emp_id)
      .filter(Boolean);

    const payload = {
      role_id: Number(roleId),
      user_name: userName,
      user_id_list,
      user_group_id_list,
      default_user_group_id_list,
    };

    console.log("Payload being sent:", payload);

    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span>Updating role...</span>
        </div>
      </div>
    );
    setActiveImg(InterogativeImg);

    try {
      const res = await fetch(
        `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const json = await res.json();

      if (json.status === 200) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Role updated successfully!</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      } else {
        setActiveImg(ErrorImg);
        const errorMessage =
          json.status === 500
            ? "Internal Server Error! Please contact admin."
            : json.message || "Failed to update role!";
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <span>{errorMessage}</span>
            </div>
          </div>
        );
      }
    } catch (error) {
      setActiveImg(ErrorImg);
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span>Something went wrong!</span>
          </div>
        </div>
      );
    }
  };

  const headers = [
    "User ID",
    "User/Group Name",
    "Employee Name",
    "Staff Number",
    "Designation",
    "Department",
    "Branch",
    "Status",
    "User Count",
    "Identifier",
  ];

  return (
    <div className="create-role-container">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">Assign User to Role</span>
        <div className="cr-header-btn-container">
          <button
            className="cr-cancel-btn"
            onClick={() => navigate("/create_role_dashboard")}
          >
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>

      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>ROLE DETAILS</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionRoleDetails}>
            {isOpenRoleDetails ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenRoleDetails && (
          <div className="accordion-content">
            <div className="select-assign-test-container-ques-pap-del">
              <div className="grid-container-ques-paper-del">
                <div className="item1">
                  <FormInputs
                    label="Role Name"
                    type="text"
                    required
                    value={roleName}
                    onChange={(e) => setRoleName(e.target.value)}
                    disabled
                  />
                </div>
                <div className="item2">
                  <FormInputs
                    label="Role Code"
                    type="text"
                    required
                    value={roleCode}
                    onChange={(e) => setRoleCode(e.target.value)}
                    disabled
                  />
                </div>
                <div className="item3">
                  <FormInputs
                    label="Status"
                    type="text"
                    value={roleStatus === 1 ? "Active" : "Inactive"}
                    disabled
                  />
                </div>
                <div
                  className="item4-creaete-role-description"
                  style={{ gridColumn: "1 / -1" }}
                >
                  <FormInputs
                    label="Description"
                    type="textarea"
                    className="create-role-description-field"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    required
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="ques-paper-del" style={{ marginTop: "20px" }}>
        <div className="personal-header">
          <div className="header">
            <label>ADD USER/GROUP</label>
          </div>
          <div className="accordion-btn" onClick={toggleAccordionShareBranch}>
            {isOpenShareBranch ? (
              <div className="minus"></div>
            ) : (
              <div className="plus">+</div>
            )}
          </div>
        </div>

        {isOpenShareBranch && (
          <div className="accordion-content">
            <div
              className="select-assign-test-container-ques-pap-del"
              style={{ padding: "20px 0px 20px 0px" }}
            >
              <div className="grid-container-ques-paper-del">
                <div className="item1" style={{ marginLeft: "20px" }}>
                  <DropdownWithPagination
                    label="Add User/Group"
                    width="100%"
                    selected={selectedStudents}
                    setSelected={(vals) => {
                      // Dropdown may return numbers or strings; normalize to strings
                      const normalized = (Array.isArray(vals) ? vals : []).map(
                        String
                      );
                      setSelectedStudents(normalized);
                    }}
                    onSearchInputChange={fetchStudents}
                    options={studentOptions}
                    isRequired={true}
                    showSelectAll={false}
                    itemsPerPage={4}
                    placeholder="Type to search users/groups..."
                  />
                </div>

                <div style={{ gridColumn: "1 / -1", marginTop: 16 }}>
                  <TableWithCrossStudentGroup
                    headers={headers}
                    data={tableData}
                    searchPlaceholder="Search user..."
                    selectedRows={selectedStudents}
                    setSelectedRows={handleTableRowSelection}
                    renderQuestionText={(text) => text}
                    renderQuestionTextModel={(text) => text}
                    expandedStates={{}}
                    toggleImage={() => {}}
                    pageType="userEdit"
                    onRowLinkClick={(row) => console.log("Row clicked:", row)}
                    filterConfig={{}}
                    handleDeleteRow={handleDeleteRow}
                    hideIdColumn={true}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UpdatedAssignToRole;

// const updateRoleStatus = async (newStatus) => {
//   const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");

//   if (!roleId) return;

//   const payload = {
//     role_id: Number(roleId),
//     user_name: userName,
//     status: newStatus,
//     user_id_list: [],
//     user_group_id_list: [],
//     default_user_group_id_list: [],
//   };

//   // Show loader
//   setIsMessageBoxVisible(true);
//   setActiveImg(InterogativeImg);
//   setMessageBox(
//     <div className="Container-messageBOX">
//       <div className="messagebox-insider1">
//         <div className="loader-tc"></div>
//         <span>{newStatus === 1 ? "Activating role..." : "Deactivating role..."}</span>
//       </div>
//     </div>
//   );

//   try {
//     const res = await fetch(
//       `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
//       {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       }
//     );

//     const json = await res.json();

//     if (res.ok && json.status === 200) {
//       // Success
//       setRoleStatus(newStatus);
//       setActiveImg(InterogativeImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>
//               Role {newStatus === 1 ? "activated" : "deactivated"} successfully!
//             </span>
//           </div>
//         </div>
//       );
//     } else {
//       // API returned error message
//       setActiveImg(ErrorImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>{json.message || "Operation failed!"}</span>
//           </div>
//         </div>
//       );
//     }
//   } catch (error) {
//     // Network or unexpected error
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Something went wrong!</span>
//         </div>
//       </div>
//     );
//   }
// };

//  {/* DEACTIVATE button when status = 1 */}
//           {roleStatus === 1 && (
//             <button
//               className="cr-cancel-btn"
//               style={{ width: "140px" }}
//               onClick={() => updateRoleStatus(0)}
//             >
//               DEACTIVATE
//             </button>
//           )}

//           {/* ACTIVATE button when status = 0 */}
//           {roleStatus === 0 && (
//             <button
//               className="cr-create-btn"
//               style={{ width: "140px" }}
//               onClick={() => updateRoleStatus(1)}
//             >
//               ACTIVATE
//             </button>
//           )}

// const handleSave = async () => {
//   const roleId = new URLSearchParams(location.search).get("MNTCreatedRoleID");
//   if (!selectedStudents || selectedStudents.length === 0) {
//     setActiveImg(ErrorImg);
//     setIsMessageBoxVisible(true);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Please select at least one User or Group!</span>
//         </div>
//       </div>
//     );
//     return;
//   }

//   // Build selected fullData list from allSelectedUsersData
//   const selectedFullData = (selectedStudents || [])
//     .map((id) => allSelectedUsersData.find((o) => o.id === id))
//     .filter(Boolean)
//     .map((o) => o.fullData);

//   // Users = identifier === 1 or undefined -> send user_id or emp_id
//   const user_id_list = selectedFullData
//     .filter((d) => d.identifier === 1)
//     .map((d) => d.user_id);

//   // User Groups = identifier === 2
//   const user_group_id_list = selectedFullData
//     .filter((d) => d.identifier === 2)
//     .map((d) => d.emp_id);

//   // Default User Group = identifier === 3
//   const default_user_group_id_list = selectedFullData
//     .filter((d) => d.identifier === 3)
//     .map((d) => d.emp_id);

//   const payload = {
//     role_id: Number(roleId),
//     user_name: userName,
//     user_id_list,
//     user_group_id_list,
//     default_user_group_id_list,
//   };

//   setIsMessageBoxVisible(true);
//   setActiveImg(InterogativeImg);
//   setMessageBox(
//     <div className="Container-messageBOX">
//       <div className="messagebox-insider1">
//         <div className="loader-tc"></div>
//         <span>Updating role...</span>
//       </div>
//     </div>
//   );

//   try {
//     const res = await fetch(
//       `${FULL_API_BASE_URL}/update-role-user-n-user-groups`,
//       {
//         method: "PUT",
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       }
//     );

//     const json = await res.json();

//     if (json.status === 200) {
//       setActiveImg(InterogativeImg);
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <div className="loader-tc"></div>
//             <span>Role updated successfully!</span>
//           </div>
//         </div>
//       );
//       setTimeout(() => {
//         window.location.reload();
//       }, 1200);
//     } else {
//       setActiveImg(ErrorImg);
//       const errorMessage =
//         json.status === 500
//           ? "Internal Server Error! Please contact admin."
//           : json.message || "Failed to update role!";
//       setMessageBox(
//         <div className="Container-messageBOX">
//           <div className="messagebox-insider1">
//             <span>{errorMessage}</span>
//           </div>
//         </div>
//       );
//     }
//   } catch (error) {
//     setActiveImg(ErrorImg);
//     setMessageBox(
//       <div className="Container-messageBOX">
//         <div className="messagebox-insider1">
//           <span>Something went wrong!</span>
//         </div>
//       </div>
//     );
//   }
// };
